import { Text, useTheme } from '@querodelivery/uni-react';
import { EMissionStatus, TRANSLATE_MISSION_STATUS } from '../../constants';
import styles from './mission-status-badge.module.scss';
import { colors } from '@/Themes/Colors';

export const MissionStatusBadge = ({ status }: { status: EMissionStatus }) => {
  const { color } = useTheme();
  const COLORS_BY_STATUS: Record<
    EMissionStatus,
    {
      backgroundColor: string;
      iconColor: string;
      textTone: 'success' | 'error' | 'supporting';
    }
  > = {
    [EMissionStatus.ACTIVE]: {
      backgroundColor: color['color-success-fill-disable'],
      iconColor: color['color-success-on-fill-disable'],
      textTone: 'success',
    },
    [EMissionStatus.FINISHED]: {
      backgroundColor: color['color-danger-fill-disable'],
      iconColor: color['color-danger-on-fill-disable'],
      textTone: 'error',
    },
    [EMissionStatus.CANCELED]: {
      backgroundColor: colors.gray70,
      iconColor: color['color-base-border-2'],
      textTone: 'supporting',
    },
    [EMissionStatus.PENDING]: {
      backgroundColor: colors.gray70,
      iconColor: color['color-base-border-2'],
      textTone: 'supporting',
    },
  };

  return (
    <div
      className={styles.missionStatus}
      style={{ backgroundColor: COLORS_BY_STATUS[status].backgroundColor }}
    >
      <div
        className={styles.statusIcon}
        style={{
          backgroundColor: COLORS_BY_STATUS[status].iconColor,
        }}
      />
      <Text
        variant="bodyXs"
        tone={COLORS_BY_STATUS[status].textTone}
        fontWeight="medium"
      >
        {TRANSLATE_MISSION_STATUS[status]}
      </Text>
    </div>
  );
};
